import React, { useEffect, useState, useCallback } from "react";
import Logger from "./Logger";
import { getLoggerBaseURL } from "../utils/getLoggerBaseURL";

// Initialize Logger
const logger = new Logger(getLoggerBaseURL());

function MiniBlinkingDot() {
  return (
    <span className="relative flex h-2 w-2 mr-1">
      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75"></span>
      <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
    </span>
  );
}

export default function LiveOrderStats() {
  const [totalOrders, setTotalOrders1] = useState(0);
  const [unassignedOrders, setUnassignedOrders1] = useState(0);
  const [incompletedOrders, setIncompletedOrders1] = useState(0);
  const [completedOrders, setCompletedOrders1] = useState(0);
  const userEmail = sessionStorage.getItem("userEmail");

  const fetchData = useCallback(async () => {
    try {
      const res = await fetch(`/api/dashboard/kpi/${userEmail}`);
      if (!res.ok) throw new Error(`API error: ${res.status}`);
      const data = await res.json();

      setTotalOrders1(data.today?.total || 0);
      setUnassignedOrders1(data.today?.unassigned || 0);
      setIncompletedOrders1(data.today?.inProgress || 0);  // inProgress = "in progress" = your "incomplete"
      setCompletedOrders1(data.today?.completed || 0);

    } catch (error) {
      logger.log(`Error fetching order stats: ${error}`, "ERROR");
    }
  }, [userEmail]);

  useEffect(() => {
    fetchData();

    const interval = setInterval(fetchData, 1.5 * 60 * 1000);
    const onOrdersUpdated = () => fetchData();
    window.addEventListener("zordigo-orders-updated", onOrdersUpdated);
    window.addEventListener("focus", onOrdersUpdated);

    return () => {
      clearInterval(interval);
      window.removeEventListener("zordigo-orders-updated", onOrdersUpdated);
      window.removeEventListener("focus", onOrdersUpdated);
    };
  }, [fetchData]);

  return (
    <div className="flex items-center space-x-1 text-xs absolute shadow-md bg-white/90 border border-gray-200 rounded-full px-3 py-1 backdrop-blur-sm" >
      <div className="flex items-center text-gray-800 font-semibold mr-2">
        <MiniBlinkingDot />
        Live
      </div>
      <span className="bg-gray-100 text-gray-700 px-2 py-0.5 rounded-sm flex flex-row items-center gap-1">
        Total:{" "}
        <span className="font-bold text-blue-600 text-base ml-1">
          {totalOrders}
        </span>
      </span>
      <span className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-sm flex flex-row items-center gap-1">
        Unassigned:{" "}
        <span className="font-bold text-blue-700 text-base ml-1">
          {unassignedOrders}
        </span>
      </span>
      <span className="bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-sm flex flex-row items-center gap-1">
        Incomplete:{" "}
        <span className="font-bold text-yellow-700 text-base ml-1">
          {incompletedOrders}
        </span>
      </span>
      <span className="bg-green-100 text-green-800 px-2 py-0.5 rounded-sm flex flex-row items-center gap-1">
        Completed:{" "}
        <span className="font-bold text-green-700 text-base ml-1">
          {completedOrders}
        </span>
      </span>
    </div>
  );
}
